export type TicketPriority = 'low' | 'normal' | 'high' | 'urgent';

const PRIORITY_ORDER: Record<TicketPriority, number> = {
  urgent: 0,
  high: 1,
  normal: 2,
  low: 3,
};

const PRIORITY_LABELS: Record<TicketPriority, string> = {
  low: 'Baja',
  normal: 'Normal',
  high: 'Alta',
  urgent: 'Urgente',
};

export function normalizeTicketPriority(value: string | undefined | null): TicketPriority {
  if (value === 'low' || value === 'high' || value === 'urgent') return value;
  return 'normal';
}

export function getPriorityLabel(priority: string | undefined | null): string {
  return PRIORITY_LABELS[normalizeTicketPriority(priority)];
}

export function getPriorityBadgeTone(
  priority: string | undefined | null
): 'neutral' | 'info' | 'warning' | 'danger' {
  switch (normalizeTicketPriority(priority)) {
    case 'urgent':
      return 'danger';
    case 'high':
      return 'warning';
    case 'low':
      return 'info';
    default:
      return 'neutral';
  }
}

export function isUrgentPriority(priority: string | undefined | null): boolean {
  return normalizeTicketPriority(priority) === 'urgent';
}

export function sortTicketsByPriority<T extends { priority?: string; created_at?: string }>(
  tickets: T[]
): T[] {
  return [...tickets].sort((a, b) => {
    const priorityDiff =
      PRIORITY_ORDER[normalizeTicketPriority(a.priority)] -
      PRIORITY_ORDER[normalizeTicketPriority(b.priority)];
    if (priorityDiff !== 0) return priorityDiff;
    if (a.created_at && b.created_at) {
      return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
    }
    return 0;
  });
}

export const TICKET_PRIORITY_OPTIONS: { value: TicketPriority; label: string }[] = [
  { value: 'low', label: 'Baja' },
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'Alta' },
  { value: 'urgent', label: 'Urgente' },
];
